"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serializeError = serializeError;
var _axios = require("@ori/axios");
var _fetchErrors = require("@ori/fetch-errors");
function serializeError(originalError) {
  if (originalError == null) {
    return undefined;
  }
  if (!(originalError instanceof Error)) {
    return {
      name: 'UnknownError',
      message: 'Unknown server-side error occurred',
      stack: ''
    };
  }
  let error = originalError;
  if ((0, _axios.isAxiosError)(error)) {
    error = new _fetchErrors.ExtendedAxiosError(error);
  }
  const serializableError = {
    name: error.name || 'Error',
    message: error.message || 'No message',
    stack: error.stack ?? 'No stack trace'
  };
  if (error.cause != null) {
    // If there is a cause, serialize it recursively
    serializableError.cause = serializeError(error.cause);
  }
  if (error instanceof _fetchErrors.ExtendedAxiosError) {
    serializableError.fetchInfo = {
      baseUrl: error.baseUrl ?? undefined,
      pathname: error.pathname ?? undefined,
      method: error.method ?? undefined,
      statusCode: error.statusCode ?? undefined,
      statusText: error.statusText ?? undefined,
      responseBody: error.responseBody
    };
    if (error instanceof _fetchErrors.GraphqlError) {
      serializableError.fetchInfo.graphqlQuery = error.graphqlQuery ?? undefined;
      serializableError.fetchInfo.graphqlVariables = error.graphqlVariables;
    }
  }
  return serializableError;
}
